import * as selectors from './account-types-selectors';
import * as types from './account-types-types';

export const AccountTypes = {
    ...selectors,
    ...types,
} as const;
